/**
 * HALLOWEEN THEME SWITCH
 * Set to `true` to activate full-site Halloween decorations.
 * Set to `false` to instantly turn off all Halloween decorations across the entire website.
 */
export const HALLOWEEN_ENABLED = false;
